import { cn } from "cn"

/**
 * Girando enquanto espera. Desenhado aqui (um arco no traço dos ícones do
 * painel), e não da lucide: biblioteca de ícone devolve o traço de todo mundo.
 */
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      data-slot="spinner"
      role="status"
      aria-label="Carregando"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={cn("size-4 animate-spin", className)}
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.2-8.56" />
    </svg>
  )
}

export { Spinner }
